import {Component, Inject, Injector, Input, PLATFORM_ID} from '@angular/core';
import {ArticleSliderComponent} from "@iw-shop/article/components/slider/article-slider.component";
import {DynamicPageService} from "@iw-shop/dynamic-page/services/dynamic-page.service";
import {combineLatest, Observable, Subject, takeUntil} from "rxjs";
import {map} from "rxjs/operators";
import {ActivatedRoute, Router} from "@angular/router";
import {AppState} from "@store/state/app.state";
import {Store} from "@ngrx/store";
import {SEOTags, setBreadcrumb} from "@store/actions/global.actions";
import {ContactFormComponent} from "@iw-shop/contact/components/contact-form/contact-form.component";
import {isPlatformBrowser} from "@angular/common";
import {ArticleMenuGroupsComponent} from "@iw-shop/article/components/menu-groups/article-menu-groups.component";
import {createCustomElement} from "@angular/elements";
import {ContactDynamicComponent} from "@iw-shop/contact/components/contact-dynamic/contact-dynamic.component";
import {ImageSliderComponent} from "@iw-shop/dynamic-page/components/image-slider/image-slider.component";
import {
    DefaultTermsAndConditionsComponent
} from "@iw-shop/dynamic-page/components/default-terms-and-conditions/default-terms-and-conditions.component";
import {
    DefaultWithdrawalComponent
} from "@iw-shop/dynamic-page/components/default-withdrawal/default-withdrawal.component";
import {DefaultImprintComponent} from "@iw-shop/dynamic-page/components/default-imprint/default-imprint.component";

@Component({
    selector: 'iw-shop-dynamic-page',
    standalone: false,
    templateUrl: './dynamic-page.component.html',
    styleUrls: ['./dynamic-page.component.scss']
})
export class DynamicPageComponent {

    @Input() uniqueName?: string;

    destroy$: Subject<boolean> = new Subject<boolean>();

    content?: string;
    isBrowser: boolean = false;
    loading: boolean = false;

    constructor(private injector: Injector, private dynamicPageService: DynamicPageService, private route: ActivatedRoute, private store: Store<AppState>, private router: Router, @Inject(PLATFORM_ID) platformId: Object) {
        this.isBrowser = isPlatformBrowser(platformId);
    }

    protected createCustomElements(){
        if (this.isBrowser) {
            import('@angular/elements').then(module => {
                if (!customElements.get('tpl_article-slider')) {
                    const elementSlider = createCustomElement(ArticleSliderComponent, {injector: this.injector});
                    customElements.define('tpl_article-slider', elementSlider);
                    const contactForm = createCustomElement(ContactFormComponent, {injector: this.injector});
                    customElements.define('tpl_contact-form', contactForm);
                    const articleMenuGroups = createCustomElement(ArticleMenuGroupsComponent, {injector: this.injector});
                    customElements.define('tpl_article-menu-groups', articleMenuGroups);
                    const contactDynamic = createCustomElement(ContactDynamicComponent, {injector: this.injector});
                    customElements.define('tpl_contact-dynamic', contactDynamic);
                    const imageSlider = createCustomElement(ImageSliderComponent, {injector: this.injector});
                    customElements.define('tpl_image-slider', imageSlider);
                    const elementTermsAndConditions = createCustomElement(DefaultTermsAndConditionsComponent, {injector: this.injector});
                    customElements.define('tpl_default-terms-and-conditions', elementTermsAndConditions);
                    const elementWithdrawal = createCustomElement(DefaultWithdrawalComponent, {injector: this.injector});
                    customElements.define('tpl_default-withdrawal', elementWithdrawal);
                    const elementImprint = createCustomElement(DefaultImprintComponent, {injector: this.injector});
                    customElements.define('tpl_default-imprint', elementImprint);
                }
            });
        }
    }


    ngOnInit() {
        this.createCustomElements();
        if(this.uniqueName){

            this.loadDynamicPage(this.uniqueName);
        } else {
            const urlParams: Observable<any> = combineLatest(
                [
                    this.route.params,
                    this.route.queryParams
                ]
            ).pipe(
                map(([params, queryParams]) => ({...params, ...queryParams}))
            );
            urlParams
                .pipe(
                    takeUntil(this.destroy$)
                )
                .subscribe(
                    params => {
                        let path = '';
                        if (params['path']) {
                            path = params['path']
                        }
                        this.store.dispatch(setBreadcrumb({breadcrumb: {level1: undefined}}));
                        this.loadDynamicPage(path)
                    }
                )
        }



    }

    loadDynamicPage(path: string) {
        this.loading = true;
        this.dynamicPageService.get({
            filters: [{fields: ['uniqueName'], values: [path]}, {
                fields: ['status'],
                values: ['online']
            }], dynamicPages: {}
        })
            .subscribe(
                r => {
                    if (r.result?.dynamicPages.data[0]) {
                        let page = r.result?.dynamicPages.data[0];

                        if(page?.routerLink){
                            this.router.navigate([page.routerLink]).then();
                            return;
                        }
                        if(page?.externalLinkUrl && page.externalLinkUrl.length > 0){
                            window.location.href = page.externalLinkUrl;
                            return;
                        }
                        this.store.dispatch(SEOTags({
                            title: page?.SEO?.title ?? '',
                            description: page?.SEO?.description ?? '',
                            keywords: page?.SEO?.keywords ?? '',
                            useForUrl: this.router.routerState.snapshot.url
                        }));


                        this.content = page.content.split('<h1>').join('<h1 class="title">').split('<h2>').join('<h2 class="subtitle">');
                        if (page?.uniqueName != '') {
                            this.store.dispatch(setBreadcrumb({breadcrumb: {level1: {name: page?.name}}}));
                        }
                    }
                    if(path == 'vertrag-widerrufen'){
                        this.store.dispatch(setBreadcrumb({breadcrumb: {level1: {name: 'Vertrag widerrufen'}}}));
                        this.content = '        <div class="columns">\n' +
                            '            <div class="column is-8-desktop pt-6-desktop">\n' +
                            '<tpl_contact-dynamic headline="Widerruf bestätigen" email_subject="Vertrag / Bestellung widerrufen" submit_label="Widerruf bestätigen" require_terms_acceptance="false" fields_json=\'[{"field": {"label": "Name des Kunden", "required": true}}, {"field": {"label": "Bestell-, Vertrags oder Auftragsnummer", "required": true}}, {"field": {"label": "E-Mail", "required": true}}]\'></tpl_contact-dynamic>\n' +
                        '            <div class="column is-2"></div>\n' +
                            '            </div>\n'
                    }
                    this.loading = false;
                }
            )
    }

    processLinks(e: any) {
        const element: HTMLElement = e.target;
        let href;
        // Das angeklickte Element ist kein Link, aber ggf. ist es in einen Link verschachtelt
        if (element.nodeName != 'a' &&
            e.target.closest('a') &&
            e.target.closest('a').getAttribute('target') == 'router') {
            href = e.target.closest('a').getAttribute('href');
            // Das angeklickte Element ist ein Link
        } else if(element.getAttribute('target') == 'router') {
            href = element.getAttribute('href');
        }
        if (href) {
            e.preventDefault();
            this.router.navigate([href]).then(() => () => {
            });
        }
    }

    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
    }
}
